import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as $ from 'jquery'
@Injectable()
export class LoaderService {
  isLoading = new Subject<boolean>();
  isCustomLoading = new Subject<boolean>();
  show() {
    this.isLoading.next(true);
    $("#loaderId").show();
  }
  hide() {
    this.isLoading.next(false);
    $("#loadingLabel").text("");
    $("#loadingLabel").hide();
    $("#loaderId").hide();
  }
  customshow() {
    $("#loaderId").show();
    this.isCustomLoading.next(true);
  }
  customhide() {
    $("#loaderId").hide();
    this.isCustomLoading.next(false);
  }
}













































































